import React from "react";

const NegativeList = () => {
  return (
    <div className="container ">
      <div className="my-5">
        <h1 style={{ fontWeight: "700", color: "#000045" }}>
          Negative List – List of Shariah Non-Compliant Activities and
          Transactions
        </h1>
      </div>
      <div className="text-left" style={{ color: "#72788E", fontSize: "16px" }}>
        <p>
          <ol>
            <li>
              Any business activities or transactions related to alcoholic
              drinks including production, distribution, retail and wholesale
              and supplying of services, equipment, vehicles, bottles, and raw
              materials to any persons or companies who engaged in alcoholic
              drinks related business activities.
              <br />
              <br />
            </li>
            <li>
              Any business activities or transactions related to gambling,
              including online gaming, supplying of services, equipment and
              vehicles to any persons or companies who are engaged in gambling
              related business activities.
              <br />
              <br />
            </li>
            <li>
              Any business activities or transactions related to pornography,
              ancient methodology, superstition and polytheism including
              movie/cinema outlets screening pornographic, superstitious or
              polytheistic movies, and supplying of services, equipment and
              vehicles to any persons or companies who are engaged in business
              activities related to pornography, ancient methodology,
              superstition or polytheism.
              <br />
              <br />
            </li>
            <li>
              Any business activities or transactions related to the production
              and distribution of tobacco and dangerous drugs as defined under
              the Dangerous Drugs Act 1952 (including vape and shisha).
              <br />
              <br />
            </li>
            <li>
              Any business activities or transactions related to entertainment
              especially if it involves Shariah non-compliant and/or illegal
              activities, for example criminal related activities, free mixing
              males and females, playing music with inappropriate lyrics,
              producing and screening of movies glamorizing illicit sex. It
              includes activities held at pubs, casinos, karaoke venues, spas,
              beauty/massage parlors, saloons, among others.
              <br />
              <br />
            </li>
            <li>
              Any business activities or transactions related to the rearing of
              pigs, processing and distribution of pork and all its by-products
              including supplying of services, equipment and vehicles to any
              persons or companies who are engaged in pork related business
              activities.
              <br />
              <br />
            </li>
            <li>
              Any business activities or transactions related to prostitution.
              <br />
              <br />
            </li>
            <li>
              Any business activities or transactions related to interest-based
              lending, conventional banking, stock broking, Shariah
              non-compliant brokerage, and pawn broking activities including
              supplying of services, equipment and vehicles to any persons or
              companies who are engaged in interest-based lending, stock
              broking, and pawn broking activities.
              <br />
              <br />
            </li>
            <li>
              Any business activities or transactions related to conventional
              insurance including supplying of services, equipment and vehicles
              to any persons or companies who are engaged in conventional
              insurance.
              <br />
              <br />
            </li>
            <li>
              Any business activities or transactions related to provision of
              public accommodation or lodging for examples hotels, motels,
              hostels which are suspected of condoning activities related to
              prostitution (evidenced by providing hourly room rates), alcoholic
              drinks and non-Shariah compliant activities mentioned in item 5
              above.
              <br />
              <br />
            </li>
            <li>
              Any business activities or transactions related to the production
              and distribution of idols, statues, materials and associations,
              any non-Islamic religious activities or place of worshipping other
              than Allah.
              <br />
              <br />
            </li>
            <li>
              Any restaurant serving pork and/or alcoholic drinks.
              <br />
            </li>
          </ol>
        </p>
      </div>
    </div>
  );
};

export default NegativeList;
